import get from 'lodash.get'

export default vehicle => {
  const year = get(vehicle, 'year')
  if (`${year}`.length < 4) {
    return ''
  }
  return year || null
}
